/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_BillingInputs */

const en_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan & Billing`)
};

const de_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abo & Abrechnung`)
};

const fr_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement & Facturation`)
};

const es_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan y Facturación`)
};

const it_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano & Fatturazione`)
};

const nl_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement & Facturering`)
};

const pl_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan & Rozliczenia`)
};

const fi_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaus & Laskutus`)
};

const da_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement & Fakturering`)
};

const sv_settings_section_billing = /** @type {(inputs: Settings_Section_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan & Fakturering`)
};

/**
* | output |
* | --- |
* | "Plan & Billing" |
*
* @param {Settings_Section_BillingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_section_billing = /** @type {((inputs?: Settings_Section_BillingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_BillingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_section_billing(inputs)
	if (locale === "fr") return fr_settings_section_billing(inputs)
	if (locale === "es") return es_settings_section_billing(inputs)
	if (locale === "it") return it_settings_section_billing(inputs)
	if (locale === "nl") return nl_settings_section_billing(inputs)
	if (locale === "pl") return pl_settings_section_billing(inputs)
	if (locale === "fi") return fi_settings_section_billing(inputs)
	if (locale === "da") return da_settings_section_billing(inputs)
	if (locale === "sv") return sv_settings_section_billing(inputs)
	return en_settings_section_billing(inputs)
});